import { render, staticRenderFns } from "./LegacyBaseTableComponent.vue?vue&type=template&id=6f2a7a7c&"
import script from "./LegacyBaseTableComponent.vue?vue&type=script&lang=ts&"
export * from "./LegacyBaseTableComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f2a7a7c')) {
      api.createRecord('6f2a7a7c', component.options)
    } else {
      api.reload('6f2a7a7c', component.options)
    }
    module.hot.accept("./LegacyBaseTableComponent.vue?vue&type=template&id=6f2a7a7c&", function () {
      api.rerender('6f2a7a7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/models/Table/Legacy/LegacyBaseTableComponent.vue"
export default component.exports